import { SimpleGrid, TextInput } from '@mantine/core';
import { ORG_SOCIAL_PLATFORMS, ORG_SOCIAL_PLATFORM_LABELS, type OrganizationSocialLink, type OrgSocialPlatform } from '@re/shared';
import { OrgSocialPlatformIcon } from './org-social-icons';
import { isEn } from '../lib/i18n';

export type SocialUrlsByPlatform = Record<OrgSocialPlatform, string>;

const PLATFORM_LABELS_EN: Record<OrgSocialPlatform, string> = { website: 'Website', instagram: 'Instagram', facebook: 'Facebook', twitter: 'X (Twitter)', tiktok: 'TikTok' };

export function emptySocialUrls(): SocialUrlsByPlatform {
  return Object.fromEntries(ORG_SOCIAL_PLATFORMS.map((p) => [p, ''])) as SocialUrlsByPlatform;
}

export function socialUrlsFromOrg(links: OrganizationSocialLink[] | undefined): SocialUrlsByPlatform {
  const urls = emptySocialUrls();
  for (const l of links ?? []) urls[l.platform] = l.url;
  return urls;
}

export function socialPayloadFromUrls(urls: SocialUrlsByPlatform): OrganizationSocialLink[] {
  return ORG_SOCIAL_PLATFORMS.filter((p) => urls[p].trim()).map((p) => ({ platform: p, url: urls[p].trim() }));
}

/** One URL per platform; empty = not used. */
export function OrganizationSocialLinksEditor({ value, onChange, errors = {}, disabled }: { value: SocialUrlsByPlatform; onChange: (next: SocialUrlsByPlatform) => void; errors?: Partial<Record<OrgSocialPlatform, string>>; disabled?: boolean }) {
  return (
    <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="sm">
      {ORG_SOCIAL_PLATFORMS.map((platform) => (
        <TextInput
          key={platform}
          label={isEn() ? PLATFORM_LABELS_EN[platform] : ORG_SOCIAL_PLATFORM_LABELS[platform]}
          leftSection={<OrgSocialPlatformIcon platform={platform} size={16} />}
          placeholder="https://"
          dir="ltr"
          value={value[platform]}
          disabled={disabled}
          error={errors[platform]}
          onChange={(e) => onChange({ ...value, [platform]: e.currentTarget.value })}
        />
      ))}
    </SimpleGrid>
  );
}
